import { render, staticRenderFns } from "./VCardAttention.vue?vue&type=template&id=22fa19e6&scoped=true"
import script from "./VCardAttention.vue?vue&type=script&lang=js"
export * from "./VCardAttention.vue?vue&type=script&lang=js"
import style0 from "./VCardAttention.vue?vue&type=style&index=0&id=22fa19e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa19e6",
  null
  
)

export default component.exports